const $ = require('jquery');

jQuery(document).ready(function() {
    $('.dbk-gallery').slick({
        rows: 0,
        arrows: true,
        dots: true,
        prevArrow: '<button type="button" class="slick-control slick-control--previous"><i class="far fa-arrow-left"></i></button>',
        nextArrow: '<button type="button" class="slick-control slick-control--next"><i class="far fa-arrow-right"></i></button>',
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 300,
        cssEase: 'ease-out',
        swipeToSlide: true,
        infinite: true,
        adaptiveHeight: true,
        customPaging: function (slick, index) {
            return '<button type="button" id="slick-dot-' + index + '" class="slick-dot" rel="nofollow"></button>';
        }
    });
});